'use client'
import Link from "next/link"
import dynamic from "next/dynamic";
import { Disclosure } from '@headlessui/react'

const Map = dynamic(() => import("@components/Map"), {
    loading: () => <p className="text-secondary">Loading map...</p>,
    ssr: false, // Disable server-side rendering
});

const Location = ({ districts, location, latitude, longitude, dictionary, lang }) => {

    return (
        <div className='mb-3 pb-3 border-b-[1px] border-b-forth'>
            <h2 className='text-maincolor font-semibold text-xl mb-1'>{dictionary.location}</h2>
            <div className="flex flex-col ">
                <Disclosure>
                    {({ open }) => (
                        /* Use the `open` state to conditionally change the direction of an icon. */
                        <>
                            <Disclosure.Button className="text-maincolor mt-2 cursor-pointer border-[1px] border-maincolor rounded-md px-1 hover:bg-maincolor hover:text-light" >
                                {open ? `${dictionary.hideMap}` : `${dictionary.showOnMap}`}
                                {/* <ChevronRightIcon className={open ? 'rotate-90 transform' : ''} /> */}
                            </Disclosure.Button>
                            {open && (
                                <Disclosure.Panel>
                                    <Map latitude={latitude} longitude={longitude} lang={lang} />
                                </Disclosure.Panel>)}
                        </>
                    )}
                </Disclosure>
            </div>
        </div>
    )
}

export default Location